import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Row, Col, Result } from 'antd';
import { toggleSideBar, getAccessRoutes, setIsHR } from './stores/actions'
import { getApi } from '../../shared/src/apis';
import { connect } from 'react-redux';
import { PrivteRoute } from "./utils/privteRoutes";
import Cookies from 'js-cookie';

import 'antd/dist/antd.css';
import 'react-phone-input-2/lib/style.css'
import './index.css'
import './scss/style.scss';

import Categories from './views/categories';
import { OutPutResult, NotFound, SideBar, ReleaseNotes, Navigation, Login, BrandLoader } from '@operations/shared';
import Transactions from './components/callCenterTransactions';
import CallCenterActivations from './components/CallCenterActivations';
import CallCenterMainDashboard from './components/CallCenterMainDashboard';
import CallCenterLostUsersDashboard from './components/CallCenterLostUsersDashboard';

const token = Cookies.get('token');
interface Props {
  authed: boolean,
  isHR: boolean | null,
  is_bar_collapsed: boolean,
  toggleSideBar: any,
  accessRoutes: [],
  getApi: any,
  getAccessRoutes: (arg0: []) => void,
  setIsHR: (value: boolean | null) => void
}
class App extends Component<Props> {
  state = {
    loadPermission: true,
    noPerrmision: false,
  }

  componentDidMount() {
    // console.log(process.env);

    // console.log = function () { };
    this.checkTypeOfResponsive();
    this.getPermission();
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.accessRoutes && this.props.accessRoutes &&
      prevProps.accessRoutes.length !== this.props.accessRoutes.length &&
      this.props.accessRoutes.length > 0) {
      this.setState({ noPerrmision: false })
    }
  }

  getPermission = async () => {
    try {
      this.props.setIsHR(null);
      const permission = await this.props.getApi('users/get-permissions');
      if (permission?.payload?.status === 200) {
        this.setState({ loadPermission: false })
        const rawIsHR = permission?.payload?.isHR;
        // Handle boolean / number / string values safely (e.g. "false" should be false)
        const parsedIsHR =
          rawIsHR === true ||
          rawIsHR === 1 ||
          rawIsHR === '1' ||
          rawIsHR === 'true';
        this.props.setIsHR(parsedIsHR);
        // this.setState({activePage:permission.payload.accessRoute[0].path})
        this.props.getAccessRoutes(permission?.payload?.accessRoutes)
      } else {
        // safest default: hide restricted pages if permissions fail
        this.props.setIsHR(true);
        this.setState({ loadPermission: false, noPerrmision: true })
      }
    } catch (error) {
      this.props.setIsHR(true);
      this.setState({ loadPermission: false, noPerrmision: true })
    }
  }

  checkTypeOfResponsive = () => {
    let intFrameWidth: number = window.innerWidth;
    if (intFrameWidth <= 600) {
      this.props.toggleSideBar(!this.props.is_bar_collapsed)
    } else {
      this.props.toggleSideBar(this.props.is_bar_collapsed)
    }
  }

  render() {
    const isCallCenterDashboard = window?.location?.pathname?.includes('dashboard');

    return (
      <>
        <div className="App">

          <BrowserRouter>
            <Switch>
              <Route exact path="/log-in" component={Login} />
              <>

                <div>
                  {<>

                    {this.props.authed && !isCallCenterDashboard && <Navigation />}
                    {this.state.noPerrmision && token ?
                      <Result
                        status="403"
                        title="Permission"
                        subTitle="You don't have permission to access this page"
                      /> :
                      <Row>


                        {isCallCenterDashboard ? <>
                          <PrivteRoute path='/dashboard/call-center-dashboard/:userId' component={CallCenterMainDashboard} />
                          <PrivteRoute path='/dashboard/call-center-dashboard-activation/:userId' component={CallCenterActivations} />
                          <PrivteRoute path='/dashboard/call-center-dashboard-transactions/:userId' component={Transactions} />
                          <PrivteRoute path='/dashboard/call-center-dashboard-lost-users/:userId' component={CallCenterLostUsersDashboard} />
                        </> :

                          <>
                            {this.props.authed && <Col xs={!this.props.is_bar_collapsed ? 6 : 4}
                              md={!this.props.is_bar_collapsed ? 6 : 4}
                              lg={!this.props.is_bar_collapsed ? 4 : 2}><SideBar /></Col>}
                            <Col
                              xs={!this.props.authed ? 24 : !this.props.is_bar_collapsed ? 18 : 20}
                              md={!this.props.authed ? 24 : !this.props.is_bar_collapsed ? 18 : 20}
                              lg={!this.props.authed ? 24 : !this.props.is_bar_collapsed ? 20 : 22}>
                              <Switch>
                                <Route exact path="/log-in" component={Login} />
                                {/* Handle dynamic routes */}
                                {!this.props.isHR && <PrivteRoute path='/release-notes' component={ReleaseNotes} pathUrl='release-notes' />}

                                {this.state.loadPermission ? <BrandLoader fullscreen={false} /> : this.props.accessRoutes.map((route: any, index: any) => {
                                  return <PrivteRoute key={index} exact path={`/${route.path}/:actionName?/:id?`} actionsAllowed={route.actions} pathUrl={route.path} component={Categories} replace />
                                })}

                                <PrivteRoute path='/' component={OutPutResult} />
                                <PrivteRoute component={NotFound} />
                              </Switch>
                            </Col>
                          </>}
                      </Row>
                    }</>}
                </div>

              </>
            </Switch>
          </BrowserRouter>

        </div>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  authed: state.auth.authed,
  isHR: state.auth.isHR,
  accessRoutes: state.auth.accessRoutes,
  is_bar_collapsed: state.componentReducer.is_bar_collapsed,

})
export default connect(mapStateToProps, { toggleSideBar, getApi, getAccessRoutes, setIsHR })(App);